import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { useData, getStyles } from './hooks'
import type {
  IServiceDTO,
  ENTITY_TYPES,
  CardClosingRequirements,
} from '@sales-center/common'
import { RequirementsIndicatorIcon } from '../RequirementsIndicatorIcon'
import { useTheme } from '@mui/material/styles'

type Props = {
  entityId: number
  servicesCount: number
  services: IServiceDTO[]
  entityType: ENTITY_TYPES
  schedulingVisible: boolean
  requirements: CardClosingRequirements
}

export function RequirementsIndicator(props: Props) {
  const {
    servicesCount,
    requirements: { agreementsCount, paymentsCount },
  } = props

  const {
    agreementIsComplete,
    paymentIsComplete,
    showScheduling,
    schedulingComplete,
    serviceIsComplete,
    appointmentsLoading,
    totalAppointmentCount,
  } = useData(props)
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.root}>
      <Box display="flex">
        <RequirementsIndicatorIcon isComplete={serviceIsComplete} />
        <Typography sx={styles.label}>Service ({servicesCount})</Typography>
      </Box>
      <Box display="flex">
        <RequirementsIndicatorIcon isComplete={agreementIsComplete} />
        <Typography sx={styles.label}>Agreement ({agreementsCount})</Typography>
      </Box>
      <Box display="flex">
        <RequirementsIndicatorIcon isComplete={paymentIsComplete} />
        <Typography sx={styles.label}>Payment ({paymentsCount})</Typography>
      </Box>
      {showScheduling && (
        <Box display="flex" alignItems="center">
          <RequirementsIndicatorIcon isComplete={schedulingComplete} />
          <Typography sx={styles.label}>
            Scheduling {!appointmentsLoading && `(${totalAppointmentCount})`}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
